import $ from "jquery"
import KEY_HANDLERS from "../../keyHandlers/index"
import _ from "underscore"
import *  as AT from "./at_date_picker_menu"

export default class DatePickerMenu {
    constructor({
        scheduleCalculator = null,
        addClassesStr = '',
        needShadow = undefined,
        parentEl = null,
        showClearButton = true,
        showOkCancelButtons = true,
        showMenuCb = () => {},
        hideMenuCb = () => {},
    }) {
        this.scheduleCalculator = scheduleCalculator
        this.addClassesStr = addClassesStr
        this.needShadow = _.isUndefined(needShadow) ? true : needShadow
        this.parentEl = parentEl
        this.showClearButton = showClearButton
        this.showOkCancelButtons = showOkCancelButtons
        this.showMenuCb = showMenuCb
        this.hideMenuCb = hideMenuCb
    }

    init() {
        const self = this;

        this.menu = new window.AT.menu.DatePickerMenu({
            mode: "dynamic",
            minDate: new Date(0),
            format: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M"),
            showToday: true,
            showClearButton: this.showClearButton,
            showOkCancelButtons: this.showOkCancelButtons,
            scheduleCalculator: this.scheduleCalculator,
            startDay: window.SystemSettings.weekStartDay - 1,
            value: new Date(),
            cancelOnHide: true,
            shadow: self.needShadow,
            parentEl: this.parentEl,
        });
        this.addClass(self.addClassesStr);

        this.menu.on("select", function() {
            self.selectCallback(self.getValue());
        });
        this.menu.on("datePickerClear", function() {
            self.selectCallback(null);
        });
        this.menu.on("datePickerCancel", function() {
            self.cancelCallback();
        });

        this.menu.on('beforeshow', function() {
            self.showMenuCb()
            $(window).on("resize.datePickerMenu", _.bind(self._onResize, self));
            this._removeKeydownHandler = KEY_HANDLERS.onKeyDown(function(keycode, e) {
                // ignore old event handler (ex: hide panel on escape keypressed)
                return true;
            });
        });

        this.menu.on('beforehide', function() {
            self.hideMenuCb()
            $(window).off("resize.datePickerMenu");
            if (this._removeKeydownHandler)
                this._removeKeydownHandler();
        });

        return this;
    }

    _onResize() {
        this.hide();
    }

    _onScroll() {
        this.hide();
    }

    hideMenu() {
        this.menu.hide();
    }

    hide() {
        this.menu.hide();
    }

    getValue() {
        return this.menu.picker.getValue();
    }

    setValue(value) {
        this.menu.picker.setValue(value);
    }

    showAt($el, selectCallback, cancelCallback) {
        this.selectCallback = selectCallback;
        this.cancelCallback = cancelCallback;
        this.menu.show($el[0]);
    }

    addClass(classToAdd)
    {
        this.menu.cls += " " + classToAdd;
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/dateControls/DatePickerMenu.js